'use strict';
const mmWidgets = require('../widgets/mm-widgets');
require('./section-handler-widget');
require('./show-progress-message');
require('./display-error');
const { trackEvent } = require('../start/ga-consent');

mmWidgets.fn.cognitoSigninWidget = function (cognitoApi, cognitoAuthenticator) {
	return mmWidgets.each(this, function () {
		const widget = this.sectionHandlerWidget(),
			signinSection = widget.find('[data-mm-section~="cognito-signin"]'),
			signinButton = widget.find('[data-mm-role~="cognito-signin"]'),
			resetPasswordButton = widget.find('[data-mm-role~="cognito-reset-password"]'),
			setNewPasswordButton = widget.find('[data-mm-role~="cognito-set-new-password"]'),
			requestValidationCodeButton = widget.find('[data-mm-role~="cognito-request-validation-code"]'),
			usernameField = signinSection.find('[name="cognito-username"]'),
			passwordField = signinSection.find('[name="cognito-password"]'),
			passwordRetypeField = signinSection.find('[name="cognito-password-retype"]'),
			verificationCodeField = signinSection.find('[name="cognito-password-verify"]'),
			verificationEmailSpan = widget.find('[data-mm-role~="cognito-sent-to-email"]'),
			signIn = function (username, password) {
				widget.showProgressMessage('Signing in, please wait...');
				widget.trigger('authenticating');
				//widget.trigger('verifyingCognitoUser');
				return cognitoAuthenticator.authenticate(username, password)
				.then(() => {
					widget.addClass('hidden');
					widget.trigger('authenticated');
					trackEvent({
						action: 'login',
						method: 'password'
					});
				})
				.catch((reason) => {
					if (reason === 'new-password-required') {
						passwordField.val('').focus();
						passwordRetypeField.val('');
						widget.showSection('cognito-' + reason);
						widget.trigger('newPasswordRequired');
					} else if (reason === 'no-user' || reason === 'no-password') {
						signinSection.displayError('cognito-signin-' + reason);
						widget.showSection('cognito-signin-' + reason);
						widget.trigger('noCognitoUser');
					} else {
						widget.showSection('cognito-signin');
						signinSection.displayError('cognito-signin-failed');
						widget.trigger('not-authenticated');
					}
				});
			},
			cleanup = function () {
				signinSection.displayError();
				passwordField.val('');
				passwordRetypeField.val('');
				usernameField.val('');
				verificationCodeField.val('');
				verificationEmailSpan.text('');
			};

		widget.on('show', function () {
			cleanup();
			widget.showSection('cognito-signin');
		});
		widget.on('hide', function () {
			cleanup();
		});

		signinButton.click(function () {
			const username = usernameField.val().trim().toLowerCase(),
				password = passwordField.val();
			let hasErrors = false;
			if (!username) {
				signinSection.displayError('no-cognito-username');
				hasErrors = true;
			}
			if (username && username.indexOf('@') > -1) {
				signinSection.displayError('email-entered-in-acount-name');
				hasErrors = true;
			}
			if (!password) {
				signinSection.displayError('no-cognito-password', hasErrors);
				hasErrors = true;
			}
			if (!hasErrors) {
				signinSection.displayError();
				signIn(username, password);
			}
			widget.trigger('signinButtonClicked');
		});

		requestValidationCodeButton.click(function () {
			const username = usernameField.val();
			let hasErrors = false;
			if (!username) {
				signinSection.displayError('no-cognito-username');
				hasErrors = true;
			}
			if (username && username.indexOf('@') > -1) {
				signinSection.displayError('email-entered-in-acount-name');
				hasErrors = true;
			}

			if (!hasErrors) {
				signinSection.displayError();
				widget.showProgressMessage('Requesting validation code, please wait...');
				cognitoApi.requestPasswordReset(username)
				.then((response) => {
					if (response && response.maskedEmail) {
						widget.find('[data-mm-role~="cognito-sent-to-email"]').text(response.maskedEmail);
					}
					widget.showSection('cognito-verify-password-reset');
				})
				.catch((reason) => {
					if (reason === 'no-user') {
						signinSection.displayError('cognito-signin-' + reason);
						widget.showSection('cognito-signin-' + reason);
						widget.trigger('noCognitoUser');
					} else {
						widget.showSection('cognito-request-password-reset');
						signinSection.displayError(reason || 'cognito-request-password-failed');
					}
				});
			}
			widget.trigger('requestValidationCodeButtonClicked');
		});

		setNewPasswordButton.click(() => {
			const password = passwordField.val(),
				passwordRetype = passwordRetypeField.val();
			let hasErrors = false;
			signinSection.displayError();
			if (!password) {
				signinSection.displayError('no-cognito-password', hasErrors);
				hasErrors = true;
			} else if (password !== passwordRetype) {
				signinSection.displayError('cognito-password-mismatch', hasErrors);
				hasErrors = true;
			}
			if (hasErrors) {
				widget.trigger('setNewPasswordButtonClicked');
				return;
			}
			widget.showProgressMessage('Setting new password, please wait...');
			cognitoApi.completePendingUserAction(password)
			.then(() => {
				const username = usernameField.val();
				signIn(username, password);
			})
			.catch((reason) => {
				widget.showSection('cognito-new-password-required');
				signinSection.displayError(reason || 'cognito-new-password-required-failed');
			});
			widget.trigger('setNewPasswordButtonClicked');
		});

		resetPasswordButton.click(function () {
			const username = usernameField.val(),
				password = passwordField.val(),
				passwordRetype = passwordRetypeField.val(),
				verificationCodeRaw = verificationCodeField.val(),
				verificationCode = verificationCodeRaw && verificationCodeRaw.trim && verificationCodeRaw.trim();
			let hasErrors = false;
			signinSection.displayError();
			if (!verificationCode) {
				signinSection.displayError('no-cognito-verification-code', hasErrors);
				hasErrors = true;
			}
			if (!password) {
				signinSection.displayError('no-cognito-password', hasErrors);
				hasErrors = true;
			} else if (password !== passwordRetype) {
				signinSection.displayError('cognito-password-mismatch', hasErrors);
				hasErrors = true;
			}
			if (hasErrors) {
				return;
			}
			widget.showProgressMessage('Resetting password, please wait...');
			cognitoApi.completePendingUserAction(password, verificationCode)
			.then(function () {
				return signIn(username, password);
			})
			.catch(reason => {
				widget.showSection('cognito-verify-password-reset');
				signinSection.displayError(reason || 'cognito-request-password-failed');
			});

		});
	});

};

